<template>
    <div class="t-lk-modal__content">
        <h2 class="t-lk-modal__title">{{ $root.staticText.lk.staffAdd }}</h2>
        <div class="t-lk-modal__text">{{ $root.staticText.lk.staffAddText }}</div>

        <form
            class="t-form t-lk-modal__form _add-staff"
            :class="{ _disabled: infoForm.disabledForm }"
            @submit.stop.prevent="submitForm()"
        >
            <div class="t-feedback__content">
                <div
                    v-for="(item, index) in cmpForm"
                    class="t-feedback__item"
                >
                    <div
                        v-if="item.title"
                        class="t-form__label"
                    >
                        {{ item.title }}
                        <span v-if="item.requiredField">*</span>
                    </div>

                    <input
                        v-if="item.type === 'text'"
                        class="t-input"
                        :class="{ _error: item.error, _valid: item.valid }"
                        :type="item.type"
                        :placeholder="item.hintField"
                        v-model="item.value"
                        @focus="focusForm(index)"
                    />

<!--                    <masked-input-->
<!--                        v-if="item.type === 'phone'"-->
<!--                        class="t-input"-->
<!--                        :class="{ _error: item.error, _valid: item.valid }"-->
<!--                        mask="\+\7(111)111-11-11"-->
<!--                        :placeholder="item.hintField"-->
<!--                        v-model="item.value"-->
<!--                        @input="focusForm(index)"-->
<!--                        :ref="index"-->
<!--                    />-->

<!--                    <input-->
<!--                        v-if="item.type === 'password'"-->
<!--                        class="t-input"-->
<!--                        :class="{'_error': item.error, '_valid': item.valid}"-->
<!--                        :type="item.type"-->
<!--                        :placeholder="item.hintField"-->
<!--                        v-model="item.value"-->
<!--                        @focus="focusForm(index)"-->
<!--                    />-->

                </div>
            </div>

            <vue-recaptcha
                ref="recaptcha"
                size="invisible"
                :sitekey="$root.sitekeyRecaptcha"
                :load-recaptcha-script="true"
                @verify="onCapchaRegister"
                @expired="onCaptchaExpired"
                @error="errorCaptcha"
            />
            <button class="t-btn _lk _green">{{ $root.staticText.lk.staffAddBtn }}</button>
        </form>
    </div>
</template>

<script>
    import {mapActions, mapMutations} from "vuex";
    import Vue from "vue";
    import VueRecaptcha from "vue-recaptcha";

    export default {
        name: "request",
        props: ['props'],
        data() {
            return {
                recaptchaToken: null,
                isValid: false,
                classWhite: false,
                infoForm: {
                    action: "lk/addStaff",
                    disabledForm: false,
                    success: false,
                    error: false,
                },
                cmpForm: [
                    // {
                    //     title: this.$root.staticText.forms.fullName,
                    //     id: 'name',
                    //     type: 'text',
                    //     value: '',
                    //     hintField: this.$root.staticText.forms.placeholderFullName,
                    //     error: false,
                    //     valid: false,
                    //     requiredField: true,
                    //     pattern: /\S{2,}/i
                    // },
                    {
                        title: this.$root.staticText.forms.email,
                        id: 'email',
                        type: 'text',
                        value: '',
                        hintField: this.$root.staticText.forms.placeholderEmail,
                        error: false,
                        valid: false,
                        requiredField: true,
                        pattern: /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i
                    },
                    {
                        title: this.$root.staticText.forms.position,
                        id: 'position',
                        type: 'text',
                        value: '',
                        hintField: this.$root.staticText.forms.positionPlaceholder,
                        error: false,
                        valid: false,
                        requiredField: true,
                        pattern: /\S{2,}/i
                    },
                    // {
                    //     title: this.$root.staticText.forms.phone,
                    //     id: 'phone',
                    //     type: 'phone',
                    //     value: '',
                    //     hintField: '+7',
                    //     error: false,
                    //     valid: false,
                    //     requiredField: true,
                    //     pattern: /^\+\d{1,3}\s?\(\d{3}\)\s?\d{3}(-\d{2}){2}$/
                    // },
                    // {
                    //     title: this.$root.staticText.lk.password,
                    //     id: 'password',
                    //     type: 'password',
                    //     value: '',
                    //     hintField: this.$root.staticText.lk.placeholderPassword,
                    //     error: false,
                    //     valid: false,
                    //     requiredField: true,
                    //     pattern: /\S{8,}/i,
                    // },
                    // {
                    //     title: this.$root.staticText.lk.passwordRepeat,
                    //     id: 'passwordRepeat',
                    //     type: 'password',
                    //     value: '',
                    //     hintField: this.$root.staticText.lk.placeholderPasswordRepeat,
                    //     error: false,
                    //     valid: false,
                    //     requiredField: true,
                    //     pattern: /\S{8,}/i,
                    // },
                ]
            }
        },
        components: {
            VueRecaptcha,
        },
        methods: {
            ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),
            ...mapMutations('lk', ['setStaff']),

            onCapchaRegister(recaptchaToken) {
                this.recaptchaToken = recaptchaToken;
                console.log('onCapchaRegister');
                if (this.isValid) {
                    this.sendForm();
                }
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset();
            },
            errorCaptcha() {
                console.log('errorCaptcha');
            },

            validate() {
                let is_valid = true;

                for (let i = 0; i < this.cmpForm.length; i++) {
                    this.cmpForm[i].error = false;
                    if (
                        this.cmpForm[i].pattern !== '' &&
                        (!this.cmpForm[i].requiredField ? this.cmpForm[i].value !== '' : true)
                    ) {
                        this.cmpForm[i].valid = true;
                        if (!this.cmpForm[i].pattern.test(this.cmpForm[i].value.trimEnd())) {
                            this.cmpForm[i].error = true;
                            this.cmpForm[i].valid = false;
                            is_valid = false;
                        }
                    }
                    if (
                        this.cmpForm[i].requiredField &&
                        this.cmpForm[i].value === '' &&
                        this.cmpForm[i].pattern !== ''
                    ) {
                        this.cmpForm[i].error = true;
                        this.cmpForm[i].valid = false;
                        is_valid = false;
                    }

                    if (this.cmpForm[i].name === 'passwordRepeat') {
                        if (this.cmpForm[i].value !== this.cmpForm[i - 1].value) {
                            this.cmpForm[i].error = true;
                            this.cmpForm[i].valid = false;
                            is_valid = false;
                        }
                    }
                }

                this.isValid = is_valid;
            },
            submitForm() {
                this.validate();

                if (this.isValid) {
                    this.$refs.recaptcha.execute();
                }
            },
            sendForm() {
                this.infoForm.disabledForm = true;
                let fd = new FormData();
                fd.append('recaptchaToken', this.recaptchaToken);

                for (let i = 0; i < this.cmpForm.length; i++) {
                    fd.append(this.cmpForm[i].id, this.cmpForm[i].value.toString().trimEnd());
                }

                Vue.http.post(this.infoForm.action, fd)
                    .then(response => response.json())
                    .then(data => {
                        this.infoForm.disabledForm = false;
                        if (data.success) {
                            if (data.staff) {
                                this.setStaff(data.staff);
                            }

                            this.modalClose();
                            this.modalType_lkSuccessOpen({
                                title: this.$root.staticText.lk.staffSuccessTitle,
                                text: this.$root.staticText.lk.staffSuccessText,
                                closeBthNone: true
                            });

                        } else {
                            this.openError(data);
                        }
                    })
                    .catch(data => {
                        this.infoForm.disabledForm = false;
                        this.openError(data);
                    });
            },
            focusForm(i) {
                this.cmpForm[i].error = false;
            },
            openError(data) {
                let text = this.$root.staticText.lk.lkErrorText;
                if (data.errors) {
                    let key = Object.keys(data.errors)[0];
                    if (data.errors[key][0]) {
                        text = data.errors[key][0];
                    }
                }
                this.modalType_lkErrorOpen({
                    title: this.$root.staticText.lk.lkErrorTitle,
                    text: text,
                    closeBthNone: true
                });
            },
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/addStaff.vue